export default __webpack_public_path__ + "static/media/4.58e21938.jpg";